import { firestore } from '@/firebaseConfig'
import Application from '../model/Application';

export default class ApplicationService {
    loadApplications() {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("applications").get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new Application(doc.data()));
                });

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }
}